import { render, staticRenderFns } from "./checkinfo.vue?vue&type=template&id=074c5ef2&scoped=true&"
import script from "./checkinfo.vue?vue&type=script&lang=js&"
export * from "./checkinfo.vue?vue&type=script&lang=js&"
import style0 from "./checkinfo.vue?vue&type=style&index=0&id=074c5ef2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074c5ef2",
  null
  
)

export default component.exports